
















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class Clock extends Vue {
  @Prop(Number) readonly hour!: number;
  @Prop(Number) readonly min!: number;
  @Prop({type:String, default:'300px'}) readonly size?: string;

  rotation = {hours: 0, minutes: 0};

  get hours(): { transform: string } {
    return {transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.hours}deg)`}
  }

  get minutes(): { transform: string } {
    return {transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.minutes}deg)`}
  }

  setClock(h: number, m: number): void {
    this.rotation = {
      hours: (h * 30) + (m * 0.5),
      minutes: (m * 6)
    }
  }

  mounted(): void {
    this.setClock(this.hour, this.min)
  }
}

